import cookies from "@/utils/cookies";
import Apm from "@/utils/Apm";

export default () => {
    let dataset: {
        sso_id?: number,
        user_pseud_id?: string,
        sf_profile_id?: string,
        custom_client_id?: string,
        user_cluster?: string
    } = {};

    try {
        let oesp_info_cookie = cookies.get('OESP_INFO');
        if(oesp_info_cookie){
            let oesp_info = JSON.parse(oesp_info_cookie);
            if(oesp_info && oesp_info.id) {
                dataset.sso_id = oesp_info.id;
            }
        }
    } catch (error) {
        Apm.captureError(`Add Dataset - sso_id - ${error}`)
    }

    try {
        let ga = cookies.get('_ga');
        if(ga){
            const match = ga.match(/\d+\.\d+$/);
            ga = match ? match[0] : null;
            if(ga){
                dataset.user_pseud_id = ga;
            }
        }
    } catch (error) {
        Apm.captureError(`Add Dataset - user_pseud_id - ${error}`)
    }

    try {
        let custom_client_id = cookies.get('OESP_GA_GID');
        if(custom_client_id){
            dataset.custom_client_id = custom_client_id;
        }
    } catch (error) {
        Apm.captureError(`Add Dataset - custom_client_id - ${error}`)
    }

    try {
        let sf_profile_id = cookies.get('sf_id');
        if(sf_profile_id){
            dataset.sf_profile_id = sf_profile_id;
        }
    } catch (error) {
        Apm.captureError(`Add Dataset - sf_profile_id - ${error}`)
    }

    try {
        let _es_user_cluster =cookies.get('_es_user_cluster');
        if(_es_user_cluster){
            dataset.user_cluster = _es_user_cluster;
        }
    } catch (error) {
        Apm.captureError(`Add Dataset - user_cluster - ${error}`)
    }

    return dataset
}